export const environment = {
  production: false,
  supabaseUrl: 'https://jvfqzhoteeaipdldgsge.supabase.co',
  supabaseKey: 'sb_publishable_HoY4V5LXL_FgCZiQLw9_8w_b8_wh5RT',
  PORTAL: 'https://qa.portal.savinda.lk',

  API_BASE: 'https://api.dev.meal.savinda.lk',
  cache: {
    maxSize: 5000,

    /**
     * Max Age
     *
     * @type string
     * @default 1h
     * @description TTL of the cache. Use the below format
     * 1d2h3m4s5u
     * - d - Days
     * - h - hours
     * - m - minutes
     * - s - seconds
     * - u - milliseconds
     */
    maxAge: '1d'
  },
};
